const testimonials = [
  {
    name: "María González",
    location: "Ciudad de Panamá",
    rating: 5,
    date: "Marzo 2025",
    text: "El Dr. Tejada es un excelente profesional. Me explicó todo el procedimiento de la colposcopia con mucha paciencia y claridad. Me sentí muy tranquila durante todo el proceso. 100% recomendado.",
    service: "Colposcopia Digital",
    avatar: "MG",
    color: "bg-teal-600",
  },
  {
    name: "Lucía Herrera",
    location: "Panamá",
    rating: 5,
    date: "Febrero 2025",
    text: "Vine por mi Papanicolaou anual y quedé muy satisfecha. El consultorio es limpio, moderno y el doctor es muy amable. Los resultados llegaron rápido y me los explicó con detalle. Definitivamente vuelvo.",
    service: "Papanicolaou (Pap)",
    avatar: "LH",
    color: "bg-emerald-600",
  },
  {
    name: "Valeria Moreno",
    location: "El Dorado, Panamá",
    rating: 5,
    date: "Enero 2025",
    text: "Me detectaron VPH y estaba muy asustada. El Dr. Tejada me explicó todo con calma, sin alarmarme innecesariamente. Su manejo profesional y humano me dio mucha tranquilidad. Gracias, doctor.",
    service: "Tipificación Viral",
    avatar: "VM",
    color: "bg-rose-500",
  },
  {
    name: "Andrea Castillo",
    location: "Panamá",
    rating: 5,
    date: "Diciembre 2024",
    text: "Excelente atención desde el primer momento. El doctor es muy profesional, explica todo con claridad y se nota que realmente le importa el bienestar de sus pacientes. El consultorio es muy cómodo.",
    service: "Ginecología General",
    avatar: "AC",
    color: "bg-amber-500",
  },
  {
    name: "Patricia Ruiz",
    location: "Ciudad de Panamá",
    rating: 5,
    date: "Noviembre 2024",
    text: "Tuve que hacerme una cirugía ambulatoria y el Dr. Tejada me guió en cada paso. El procedimiento fue rápido, sin complicaciones y la recuperación fue muy buena. Muy agradecida con su equipo.",
    service: "Cirugía Ambulatoria",
    avatar: "PR",
    color: "bg-slate-600",
  },
  {
    name: "Daniela Soto",
    location: "Panamá",
    rating: 5,
    date: "Octubre 2024",
    text: "Primera vez que visito un ginecólogo especialista en colposcopia y la experiencia fue muy positiva. El doctor es muy atento, el lugar está muy bien ubicado y la atención es puntual. Lo recomiendo ampliamente.",
    service: "Colposcopia Digital",
    avatar: "DS",
    color: "bg-teal-700",
  },
];

function StarRating({ count }: { count: number }) {
  return (
    <div className="flex items-center gap-0.5">
      {Array.from({ length: count }).map((_, i) => (
        <i key={i} className="ri-star-fill text-amber-400 text-sm"></i>
      ))}
    </div>
  );
}

export default function TestimonialsSection() {
  return (
    <section className="py-14 md:py-24 bg-slate-50">
      <div className="max-w-6xl mx-auto px-5 md:px-8">
        {/* Header */}
        <div className="text-center mb-10 md:mb-14">
          <span
            className="inline-block text-teal-600 text-xs md:text-sm font-semibold uppercase tracking-wider mb-3"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            Reseñas de Pacientes
          </span>
          <h2
            className="text-2xl sm:text-3xl md:text-4xl font-bold text-slate-800 mb-3"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            Lo que dicen nuestras{" "}
            <span className="italic font-normal text-teal-600" style={{ fontFamily: "'Lora', serif" }}>
              pacientes
            </span>
          </h2>
          <p
            className="text-slate-500 text-sm md:text-base max-w-xl mx-auto"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            La confianza de nuestras pacientes es nuestro mayor reconocimiento. Estas son algunas de sus experiencias.
          </p>

          {/* Overall rating badge */}
          <div className="inline-flex items-center gap-3 mt-5 bg-white border border-slate-200 rounded-full px-5 py-2.5">
            <div className="flex items-center gap-1">
              {Array.from({ length: 5 }).map((_, i) => (
                <i key={i} className="ri-star-fill text-amber-400 text-base"></i>
              ))}
            </div>
            <span className="font-bold text-slate-800 text-sm" style={{ fontFamily: "'Poppins', sans-serif" }}>
              5.0
            </span>
            <span className="text-slate-400 text-xs" style={{ fontFamily: "'Poppins', sans-serif" }}>
              · +50 reseñas verificadas
            </span>
          </div>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {testimonials.map((t) => (
            <div
              key={t.name}
              className="bg-white rounded-2xl p-6 border border-slate-100 flex flex-col gap-4 hover:-translate-y-0.5 transition-transform duration-300"
            >
              {/* Top: avatar + name + rating */}
              <div className="flex items-start gap-3">
                <div
                  className={`w-10 h-10 flex items-center justify-center rounded-full ${t.color} text-white font-bold text-sm flex-shrink-0`}
                  style={{ fontFamily: "'Poppins', sans-serif" }}
                >
                  {t.avatar}
                </div>
                <div className="flex-1 min-w-0">
                  <p
                    className="font-semibold text-slate-800 text-sm leading-tight"
                    style={{ fontFamily: "'Poppins', sans-serif" }}
                  >
                    {t.name}
                  </p>
                  <p
                    className="text-slate-400 text-xs"
                    style={{ fontFamily: "'Poppins', sans-serif" }}
                  >
                    {t.location} · {t.date}
                  </p>
                </div>
                <StarRating count={t.rating} />
              </div>

              {/* Quote */}
              <p
                className="text-slate-600 text-sm leading-relaxed flex-1"
                style={{ fontFamily: "'Poppins', sans-serif" }}
              >
                &ldquo;{t.text}&rdquo;
              </p>

              {/* Service tag */}
              <div className="flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-stethoscope-line text-teal-500 text-xs"></i>
                </div>
                <span
                  className="text-xs text-teal-600 font-medium"
                  style={{ fontFamily: "'Poppins', sans-serif" }}
                >
                  {t.service}
                </span>
              </div>
            </div>
          ))}
        </div>

        {/* Bottom CTA */}
        <div className="text-center mt-10 md:mt-12">
          <p
            className="text-slate-500 text-sm mb-4"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            ¿Lista para tu consulta? Agenda hoy mismo.
          </p>
          <a
            href="https://wa.me/50766132697?text=Hola%2C%20quiero%20agendar%20una%20cita%20con%20el%20Dr.%20Erick%20Tejada"
            target="_blank"
            rel="nofollow noopener noreferrer"
            className="inline-flex items-center gap-2 bg-teal-600 hover:bg-teal-700 text-white font-semibold px-7 py-3 rounded-full transition-all text-sm whitespace-nowrap cursor-pointer"
            style={{ fontFamily: "'Poppins', sans-serif" }}
          >
            <i className="ri-whatsapp-line"></i>
            Agendar mi cita
          </a>
        </div>
      </div>
    </section>
  );
}
